var map = {
	"./SpinT2_001.webp": 85508,
	"./SpinT2_002.webp": 16450,
	"./SpinT2_003.webp": 5807,
	"./SpinT2_004.webp": 38575,
	"./SpinT2_005.webp": 70112,
	"./SpinT2_006.webp": 12711,
	"./SpinT2_007.webp": 56160,
	"./SpinT2_008.webp": 79582,
	"./SpinT2_009.webp": 58655,
	"./SpinT2_010.webp": 30889,
	"./SpinT2_011.webp": 73931,
	"./SpinT2_012.webp": 85119,
	"./SpinT2_013.webp": 84245,
	"./SpinT2_014.webp": 28842,
	"./SpinT2_015.webp": 5656,
	"./SpinT2_016.webp": 94235,
	"./SpinT2_017.webp": 81278,
	"./SpinT2_018.webp": 99295,
	"./SpinT2_019.webp": 3584,
	"./SpinT2_020.webp": 38234,
	"./SpinT2_021.webp": 33761,
	"./SpinT2_022.webp": 52528,
	"./SpinT2_023.webp": 16068,
	"./SpinT2_024.webp": 65880,
	"./SpinT2_025.webp": 62953,
	"./SpinT2_026.webp": 78433,
	"./SpinT2_027.webp": 30677,
	"./SpinT2_028.webp": 26921,
	"./SpinT2_029.webp": 12268,
	"./SpinT2_030.webp": 54934,
	"./SpinT2_031.webp": 39625,
	"./SpinT2_032.webp": 5752,
	"./SpinT2_033.webp": 35630,
	"./SpinT2_034.webp": 37593,
	"./SpinT2_035.webp": 39806,
	"./SpinT2_036.webp": 72076,
	"./SpinT2_037.webp": 55967,
	"./SpinT2_038.webp": 31374,
	"./SpinT2_039.webp": 87896,
	"./SpinT2_040.webp": 11340,
	"./SpinT2_041.webp": 43533,
	"./SpinT2_042.webp": 26303,
	"./SpinT2_043.webp": 46502,
	"./SpinT2_044.webp": 87867,
	"./SpinT2_045.webp": 60056,
	"./SpinT2_046.webp": 39538,
	"./SpinT2_047.webp": 41030,
	"./SpinT2_048.webp": 33610,
	"./SpinT2_049.webp": 11380,
	"./SpinT2_050.webp": 51076,
	"./SpinT2_051.webp": 15354,
	"./SpinT2_052.webp": 55365,
	"./SpinT2_053.webp": 14241,
	"./SpinT2_054.webp": 70522,
	"./SpinT2_055.webp": 45358,
	"./SpinT2_056.webp": 32733,
	"./SpinT2_057.webp": 31190,
	"./SpinT2_058.webp": 29130,
	"./SpinT2_059.webp": 93332,
	"./SpinT2_060.webp": 99942,
	"./SpinT2_061.webp": 2743,
	"./SpinT2_062.webp": 73435,
	"./SpinT2_063.webp": 38812,
	"./SpinT2_064.webp": 6283,
	"./SpinT2_065.webp": 40938,
	"./SpinT2_066.webp": 92578,
	"./SpinT2_067.webp": 91854,
	"./SpinT2_068.webp": 82369,
	"./SpinT2_069.webp": 66411,
	"./SpinT2_070.webp": 79215,
	"./SpinT2_071.webp": 3817,
	"./SpinT2_072.webp": 5411
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70515;